import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import { inspectiontype } from "../lib/storage/inspection";
import { genericApi } from "../lib/genericAPI";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: `${theme.spacing.unit * 2}px`,
      maxWidth: 480,
      margin: "0 auto",
      width: "100%",
      boxSizing: "border-box",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingBottom: `${theme.spacing.unit}px`,
      marginBottom: `${theme.spacing.unit * 2}px`,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    title: {
      fontSize: "1.1rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    error: {
      backgroundColor: "#ffebee",
      color: "#c62828",
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 1.5}px`,
      borderRadius: theme.shape.borderRadius,
      marginBottom: `${theme.spacing.unit * 2}px`,
      fontSize: "13px",
      border: `1px solid #ffcdd2`,
    },
    formCard: {
      padding: `${theme.spacing.unit * 3}px`,
      display: "flex",
      flexDirection: "column",
      gap: `${theme.spacing.unit * 2}px`,
    },
    field: {
      width: "100%",
    },
    helper: {
      fontSize: "12px",
      color: theme.palette.text.secondary,
      marginTop: `-${theme.spacing.unit}px`,
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: `${theme.spacing.unit}px`,
      marginTop: `${theme.spacing.unit * 2}px`,
    },
    closeButton: {
      minWidth: "44px",
      backgroundColor: "#ffebee",
      borderColor: "#e53935",
      color: "#c62828",
      "&:hover": {
        backgroundColor: "#ffcdd2",
        borderColor: "#c62828",
      },
    },
    confirmButton: {
      minWidth: "44px",
      backgroundColor: "#43a047",
      color: "white",
      "&:hover": {
        backgroundColor: "#2e7d32",
      },
    },
  });

type InspectionJuiceFormProps = {} & WithStyles<typeof styles>;

class InspectionJuiceFormUnstyled extends React.Component<InspectionJuiceFormProps, any> {
  state = {
    classes: undefined,
    handleConfirm: undefined,
    handleClose: undefined,
    handleChange: undefined,
    inspectionid: undefined,
    juice: 0,
    errormessage: undefined,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
    this.state.handleConfirm = props.handleConfirm;
    this.state.handleClose = props.handleClose;
    this.state.inspectionid = props.inspectionid;
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const inspectionsGeneric = genericApi<inspectiontype>("inspections");
    inspectionsGeneric.findBy("id", this.state.inspectionid).then((data) => {
      if (data) {
        this.setState({
          juice: data.juice ? Number(data.juice) : 0,
        });
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.juice < 30 || this.state.juice > 75) {
      this.handleChange("juice", 30);
      this.handleValuesIncorrectNotify();
    } else {
      this.state.handleConfirm();
    }
  };

  handleChange = (stateproperty, value) => {
    this.setState({ [stateproperty]: value }, () => {
      const inspectionsGeneric = genericApi<inspectiontype>("inspections");
      inspectionsGeneric.findBy("id", this.state.inspectionid).then((data) => {
        const newData = {
          juice: this.state.juice,
        };
        inspectionsGeneric.update(this.state.inspectionid, { ...data, ...newData }).then(() => {});
      });
    });
  };

  handleValuesIncorrectNotify = () => {
    this.setState({ errormessage: "Value needs to be between 30 and 75" });
  };

  handleValuesIncorrectNotifyClose = () => {
    this.setState({ errormessage: undefined });
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography component="h2" className={classes.title}>
            Juice
          </Typography>
        </div>

        {this.state.errormessage && <div className={classes.error}>{this.state.errormessage}</div>}

        <form
          id={`internals`}
          onSubmit={(e) => {
            this.handleSubmit(e);
          }}
        >
          <Paper elevation={1} className={classes.formCard}>
            <TextField
              className={classes.field}
              label="Juice %"
              value={this.state.juice == 0 ? undefined : this.state.juice}
              onChange={(e) => {
                this.handleChange("juice", e.target.value);
              }}
              type="number"
              InputLabelProps={{ shrink: true }}
              margin="normal"
              variant="outlined"
              inputProps={{ step: "0.1", min: 0, max: 100 }}
            />
            <Typography component="div" className={classes.helper}>
              Acceptable range: 30 – 75 %
            </Typography>
          </Paper>

          <div className={classes.actions}>
            <Button variant="outlined" className={classes.closeButton} onClick={this.state.handleClose}>
              <Close />
            </Button>
            <Button type="submit" variant="contained" className={classes.confirmButton} onClick={this.handleSubmit}>
              <Check />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(InspectionJuiceFormUnstyled);
